module.exports = __webpack_public_path__ + "img/banner.c025a0c8.png";